import { useState } from "react";
import { Sheet, Button, YStack } from "tamagui";
import { colors } from "@styles/colors";
import TextCustom, { TextSize } from "@components/TextCoustom";
import { IoMdClose } from "react-icons/io";
import SheetWrapper from "@components/wrapper/SheetWrapper";
import * as basicStyle from "@styles/index";
import { statementText } from "./statementText";

interface StatementProp {
  title: string;
}
const Statement = ({ title }: StatementProp) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          setOpen(true);
        }}>
        <u style={{ color: colors.primary }}>
          <TextCustom type={TextSize.SMALL} str={title} color={colors.primary} />
        </u>
      </a>
      <SheetWrapper
        isOpen={open}
        onOpenChange={setOpen}
        title={title}
        h={95}
        bgColor={"#FFF"}
        headerProps={{
          rightIcon: { icon: IoMdClose, onPress: () => setOpen(false) },
          others: { py: basicStyle.pageMargin.register, pt: "$7" },
        }}>
        <Sheet.Overlay
          animation="lazy"
          enterStyle={{ opacity: 0 }}
          exitStyle={{ opacity: 0 }}
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        />

        <YStack py={1} px={"$7"} gap={35} pt={15}>
          {statementText(title)?.map((question) => (
            <YStack gap={8}>
              <TextCustom type={TextSize.SUBLARGE} str={`${question.title}`} bold align={"left"} />
              <TextCustom type={TextSize.SMALL} str={`${question.content}`} align={"left"} />
            </YStack>
          ))}
          <Button mb={2} bg={colors.primary} size={"$5"} color={"#FFF"} fontSize={"$6"}>
            需要線上協助？聯繫客服
          </Button>
        </YStack>
      </SheetWrapper>
    </>
  );
};

export default Statement;
